import React, { useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { AccountService } from "../../service/AccountService";
import { AuthService } from "../../service/AuthService";
import { AppContext } from "../../HomePage";

const initials = (a) => {
    const f = (a?.first_name || "").trim(), l = (a?.last_name || "").trim();
    if (f || l) return ((f[0] || "") + (l[0] || "")).toUpperCase();
    return (a?.email || "?").substring(0, 1).toUpperCase();
};

const AccountProfile = ({ account, setAccount, onSaved }) => {
    const { t, toast, setError } = React.useContext(AppContext);
    const [disabled, setDisabled] = useState(false);
    const accountService = new AccountService();

    const onChange = (e) => setAccount({ ...account, [e.target.name]: e.target.value });

    const save = () => {
        if (disabled) return;
        setDisabled(true);
        accountService.updateMyAccount(account).then(updated => {
            AuthService.setLoggedInEmail(updated.email);
            onSaved(updated);
            toast.current.show({ severity: 'success', summary: t('account.save_account', 'Account saved'), detail: t('message_detail.successful', 'Successful') });
            setDisabled(false);
        }).catch(error => { setError(error); setError(null); setDisabled(false); });
    };

    return (
        <div className="acc-section acc-narrow">
            <p className="acc-section-title">{t('account.profile.title', 'Personal information')}</p>
            <p className="acc-section-sub">{t('account.profile.sub', 'Manage your profile and sign-in identity.')}</p>

            <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
                <div className="acc-avatar" style={{ width: 52, height: 52, fontSize: 18 }}>{initials(account)}</div>
            </div>

            <div className="p-grid p-fluid">
                <div className="p-col-12 p-md-6 acc-field">
                    <label htmlFor="first_name">{t('user.first_name', 'First name')}</label>
                    <InputText id="first_name" name="first_name" value={account.first_name || ""} onChange={onChange} />
                </div>
                <div className="p-col-12 p-md-6 acc-field">
                    <label htmlFor="last_name">{t('user.last_name', 'Last name')}</label>
                    <InputText id="last_name" name="last_name" value={account.last_name || ""} onChange={onChange} />
                </div>
                <div className="p-col-12 acc-field">
                    <label>{t('user.email', 'Email')}</label>
                    <div className="acc-input-ro"><i className="pi pi-envelope" />{account.email}</div>
                    <div className="acc-hint">{t('account.profile.email_hint', 'This is your sign-in identity. Contact support to change it.')}</div>
                </div>
            </div>
            <Button label={t('actions.save', 'Save')} icon="pi pi-save" className="p-button-outlined p-button-success" onClick={save} disabled={disabled} />
        </div>
    );
};
export default AccountProfile;
